import zhFront from "./modules/zh/frontEndPage";
import enFront from "./modules/en/frontEndPage";

export default {
  zh: {
    ...zhFront,
  },
  en: {
    ...enFront,
  },
};
